import React from "react";
import { Icon } from "@iconify/react";

/**
 * One save bar for the whole console, replacing ten scattered buttons.
 *
 * WHY THIS IS NOT NEW RISK. The five "Save Flags" buttons were already
 * identical: each called the same handler and PUT the same whole flags object,
 * so four of them were pure duplication. Collapsing them makes that honest
 * rather than changing what a save does.
 *
 * 🔴 IT FIXES A REAL BUG, NOT A COSMETIC ONE. SuccessAlert and DengerAlert
 * used to render only at the top of the first card, so a failed save at the
 * bottom of a very long page reported thousands of pixels off-screen and
 * looked to the operator like nothing had happened at all.
 *
 * 🔴 ONE SAVE SPANS SIX DIFFERENT PUT KEYS AND CAN HALF SUCCEED: the flags
 * can land while the chat ladder 401s. `results` therefore reports per key and
 * a mixed outcome NEVER renders as one green success.
 */
const SaveBar = ({ pending, liveCount, saving, results, onSave, onDiscard }) => {
  const total = pending.reduce((n, p) => n + p.count, 0);
  if (!total && !results) return null;

  const failed = results ? results.filter((r) => !r.ok) : [];
  const saved = results ? results.filter((r) => r.ok) : [];

  return (
    <div
      className="position-fixed bottom-0 start-0 end-0 bg-base border-top px-24 py-12"
      style={{ zIndex: 1050, boxShadow: "0 -8px 28px rgba(5, 2, 28, 0.14)" }}
      role="status"
    >
      <div className="d-flex align-items-center gap-3 flex-wrap">
        {results ? (
          <div className="flex-grow-1 text-sm" style={{ minWidth: 220 }}>
            {saved.length > 0 && (
              <span className="text-success-600 fw-semibold d-block">
                Saved: {saved.map((r) => r.label).join(", ")}.
              </span>
            )}
            {failed.length > 0 && (
              <span className="text-danger-600 fw-semibold d-block">
                Not saved: {failed.map((r) => `${r.label} (${r.error})`).join(", ")}.
                {" "}Those sections are still open and still hold your changes.
              </span>
            )}
          </div>
        ) : (
          <div className="flex-grow-1 text-sm text-secondary-light" style={{ minWidth: 220 }}>
            <b className="text-primary-light">
              {total} unsaved change{total === 1 ? "" : "s"}
            </b>{" "}
            in {pending.map((p) => p.label).join(" and ")}
            {liveCount > 0 && (
              <span className="text-danger-600 fw-semibold">
                {" "}
                &middot; {liveCount} of them reach real members
              </span>
            )}
          </div>
        )}

        {!results && (
          <>
            <button
              type="button"
              className="btn btn-outline-secondary px-20 py-9 radius-8"
              onClick={onDiscard}
              disabled={saving}
            >
              Discard
            </button>
            <button
              type="button"
              className="btn btn-primary px-24 py-9 radius-8 d-flex align-items-center gap-2"
              onClick={onSave}
              disabled={saving}
            >
              {saving ? (
                "Saving…"
              ) : (
                <>
                  <Icon icon="mdi:content-save-outline" />
                  Save changes
                </>
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SaveBar;
